<template>
    <div class="subPage_container" :class="{ isModalOpen: clickCoin }">
        <Teleport to="#main-view">
            <div class="sort-button-container-fav sort-button-container-fav--fixed" :class="{ isModalOpen: clickCoin }">
                <div class="sort-button" style="padding-right: 60px;">{{ $t('price.coin') }}</div>
                <div class="sort-button">{{ $t('price.price') }}</div>
                <div class="sort-button">{{ $t('price.priceChange') }}</div>
            </div>
        </Teleport>
        <!-- 시세 즐겨찾기 테이블 : 시작 -->
        <div class="fav-table" :class="locale">
            <div v-for="item in filteredReceivedData" :key="item.coin" class="fav-row" @click="onFavRowClick(item)">
                <div id="fav-row-symbol">
                    <img :src="getImagePath(item.coin, item.quote)"
                        @error="handleImageError(item.coin + item.quote, $event)" alt="">
                    <div>
                        <div>{{ item.coin }}<span>/{{ item.quote }}</span></div>
                        <p>{{ item.exchange }}</p>
                    </div>
                </div>
                <!-- <div id="fav-row-vol">{{ formatVolume(item.quoteVolume) }}</div> -->
                <!-- 상승, 하락에 따른 색 변환 -->
                <!-- <div id="fav-row-change"
                    :class="{ 'positive-change-text': item.priceChangePercent > 0, 'negative-change-text': item.priceChangePercent < 0 }">
                    <div>
                        <span v-if="item.priceChangePercent > 0">+</span> {{ formatPriceChange(item.price,
                            item.priceChange) }}
                    </div>
                    <div>
                        <span v-if="item.priceChangePercent > 0">+</span> {{ formatPercent(item.priceChangePercent) }}
                    </div>
                </div> -->
                <div>${{ formatPrice(item.price) }}</div>

                 <div id="fav-row-change"
                    :class="{ 'positive-change-text': item.priceChangePercent > 0, 'negative-change-text': item.priceChangePercent < 0 }">
                    <div>
                        <span v-if="item.priceChangePercent > 0">+</span> {{ formatPercent(item.priceChangePercent) }}
                    </div>
                </div>
            </div>
            <!-- 데이터가 없을 경우 -->
            <div class="nodata" v-if="!filteredReceivedData.length">
                {{ $t('price.noData') }}<br />{{ $t('price.needReg') }}
            </div>
        </div>
        <!-- 시세 즐겨찾기 테이블 : 끝 -->
    </div>

    <!-- 즐겨찾기 코인 추가 모달창 -->
    <!-- <CoinFavModal v-if="clickCoin" @favoritesUpdated="favoritesUpdated" /> -->
    <router-view v-slot="{ Component }">
        <component
            :is="Component"
            @favoritesUpdated="favoritesUpdated"
        />
    </router-view>
    <!-- 에러 메세지 모달창 -->
    <ErrorModal :show="showErrorModal" :message="errorMessage" @close="showErrorModal = false" />
</template>


<script>
import { useI18n } from "vue-i18n";

import api from '@/api/apiAuth.js';

// import SortButton from './sub/SortButton.vue';
import ErrorModal from '@/components/modal/ErrorModal.vue';
// import CoinFavModal from "@/components/price/sub/CoinFavModal.vue";

import { mapState, mapMutations } from "vuex";

export default {
    components: {
        // SortButton, // 정렬 버튼
        // CoinFavModal, // 코인 추가 모달창
        ErrorModal, // 에러 메세지 모달창
    },
    // computed: {
    //     // 모달창
    //     ...mapState('auth', ['loginDataReceived']),
    //     ...mapState("coinReg", ["clickCoin"]),
    //     filteredReceivedData() {
    //         const fieldsToCheck = ['coin', 'quote', 'exchange', 'quoteVolume', 'priceChangePercent', 'price'];
    //         return this.receivedData.filter(item =>
    //             fieldsToCheck.every(field => item[field] != null)
    //         );
    //     },
    //     loginSuccessful() {
    //         return this.$store.state.loginStatus.loginSuccessful;
    //     }
    // },
    computed: {
        ...mapState("auth", ["loginDataReceived"]),
        ...mapState("coinReg", ["clickCoin"]),

        isCoinModalOpen() {
            return this.$route.name === "PriceFavoriteCoin";
        },

        filteredReceivedData() {
            const fieldsToCheck = [
            "coin",
            "quote",
            "exchange",
            "quoteVolume",
            "priceChangePercent",
            "price",
            ];

            return this.receivedData.filter((item) =>
            fieldsToCheck.every((field) => item[field] != null)
            );
        },

        loginSuccessful() {
            return this.$store.state.loginStatus.loginSuccessful;
        },
    },
    watch: {
        async loginSuccessful(newVal) {
            if (newVal === true) {
                try {
                    const response = await api.fetchPriceFavorites();
                    if (response.isSuccess) {
                        this.priceFavorites = response.data;
                        this.connectWebSocket();
                        this.loadSuccess();
                    }
                } catch (error) {
                    console.error('Error fetching price favorites:', error);
                }
            }
        },
    },
    data() {
        return {
            websocket: null,
            showErrorModal: false,  // 에러 메세지 모달창 상태 변수
            errorMessage: '', // 에러 메세지 모달창 텍스트

            receivedData: [], // 소켓에서 호출한 데이터
            priceFavorites: [], // price-favorites API에서 호출한 데이터
        };
    },
    setup() {
        const { locale } = useI18n();

        return {
            locale,
        };
    },
    // API에서 유저의 즐겨찾기 목록 호출
    async beforeMount() {
        try {
            const response = await api.fetchPriceFavorites();
            if (response.isSuccess) {
                this.priceFavorites = response.data;
                this.connectWebSocket();
            }
        } catch (error) {
            console.error('Error fetching price favorites:', error);
        }
    },
    mounted() {
    },
    // 창이 닫히기 직전 소켓 연결 끊기
    beforeUnmount() {
        if (this.websocket) {
            this.websocket.close();
        }
    },
    methods: {
        // 모달창
        ...mapMutations("coinReg", ["changeCoin"]),

        loadSuccess() {
            if (window.webkit && window.webkit.messageHandlers.loadHandler) {
                window.webkit.messageHandlers.loadHandler.postMessage('Load state changed.');
            }

            if (window.Android) {
                window.Android.loadTriggered();
            }

            // console.log("Load success triggered!");
        },

        async favoritesUpdated() {
            const response = await api.fetchPriceFavorites();
            if (response.isSuccess) {
                this.websocket.close();
                this.priceFavorites = response.data;
                this.connectWebSocket();
            }
        },
        showSelect() {
            this.selectStatus = !this.selectStatus;
        },

        // 소켓 통신
        connectWebSocket() {
            this.websocket = new WebSocket('wss://ws1.goya-alert.com/exc');

            this.websocket.onopen = () => {
                this.sendDataToWebSocket(this.priceFavorites);
            };

            this.websocket.onmessage = (event) => {
                const data = JSON.parse(event.data);
                this.receivedData = data;
            };

            this.websocket.onerror = (error) => {
                console.error('WebSocket Error:', error);
            };
        },
        sendDataToWebSocket(data) {
            if (this.websocket && this.websocket.readyState === WebSocket.OPEN) {
                this.websocket.send(JSON.stringify(data));
            }
        },


        // 정렬 함수
        sort(sortDetails) {
            this.sortData(sortDetails.property, sortDetails.order);
        },

        sortData(property, order) {
            this.receivedData.sort((a, b) => {
                const aValue = parseFloat(a[property]);
                const bValue = parseFloat(b[property]);
                return order === "asc" ? aValue - bValue : bValue - aValue;
            });
        },

        // 시세 차트 이동
        onFavRowClick(item) {
            this.$router.push({ name: 'TradingView', params: { exchange: item.exchange, coin: item.coin, quote: item.quote } });
        },

        // 코인별 이미지 호출
        getImagePath(coin) {
            const symbol = coin + 'USDT';
            const baseSymbol = symbol.replace('USDT', '').toLowerCase();
            try {
                return require('@/assets/images/coin_logos/' + baseSymbol + '.svg');
            } catch {
                return require('@/assets/images/coin_logos/default.svg');
            }
        },
        handleImageError(symbol, event) {
            const baseSymbol = symbol.replace('USDT', '').toLowerCase();
            event.target.src = require('@/assets/images/coin_logos/' + baseSymbol + '.png');
        },

        // 데이터 가공
        formatPrice(value) {
            if (value == null) return "NULL";

            // Convert the number to a string
            let stringValue = value.toString();
            let parts = stringValue.split('.');
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');

            stringValue = parts.join('.');

            if (stringValue.indexOf('.') !== -1) {
                stringValue = stringValue.replace(/0+$/, '');
                stringValue = stringValue.replace(/\.$/, '');
            }

            return stringValue;
        },
        formatVolume(value) {
            if (value == null) return "NULL";
            if (value >= 1e9) {
                return (value / 1e9).toFixed(2) + 'B';
            } else if (value >= 1e6) {
                return (value / 1e6).toFixed(2) + 'M';
            } else if (value >= 1e3) {
                return (value / 1e3).toFixed(2) + 'K';
            } else {
                return value.toString();
            }
        },
        formatPercent(value) {
            if (value == null) return "NULL";
            return Number(value).toFixed(2) + '%';
        },
        formatPriceChange(referenceValue, valueToFormat) {
            if (referenceValue == null || valueToFormat == null) return "NULL";
            const numericReference = Number(referenceValue);
            let numericValueToFormat = Number(valueToFormat);

            if (isNaN(numericReference) || isNaN(numericValueToFormat)) {
                return valueToFormat;
            }

            const decimalPlaces = this.countDecimalPlaces(numericReference);
            let formattedValue = numericValueToFormat.toFixed(decimalPlaces);

            formattedValue = formattedValue.replace(/(\.\d*?[1-9])0+$|\.0*$/, '$1');

            return formattedValue;
        },
        countDecimalPlaces(value) {
            if (value == null) return 0;
            if (Math.floor(value) !== value) {
                return value.toString().split(".")[1].length || 0;
            }
            return 0;
        },
        isValidItem(item) {
            // Add all the fields you want to check for nullity
            const fieldsToCheck = ['coin', 'quote', 'exchange', 'quoteVolume', 'priceChangePercent', 'price'];
            return fieldsToCheck.every(field => item[field] != null);
        },
    },
};
</script>

<style scoped>
.nodata {
    grid-column: 1 / -1;
}
</style>c